import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import ProductionContent from './components/ProductionContent';

export default function ProductionPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '專業生產｜GMP 潔淨室・5階段品管流程｜康永生技',
    description: '康永生技專業生產環境：GMP 潔淨室、研發實驗室、品管檢驗室、溫控倉儲。5階段品質管理：原料進廠檢驗、製程監控、半成品中控、成品檢驗、CoA 報告。',
    keywords: '專業生產,GMP潔淨室,品質管理,5階段品管,HACCP認證,ISO22000,保健食品生產',
    lang: 'zh-TW',
    canonicalPath: '/about/production',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="專業生產｜GMP 潔淨室・5階段品管流程｜康永生技" pageDescription="康永生技專業生產環境：GMP 潔淨室、研發實驗室、品管檢驗室、溫控倉儲。5階段品質管理：原料進廠檢驗、製程監控、半成品中控、成品檢驗、CoA 報告。" pageUrl={`${siteUrl}/about/production`} />
      <ProductionContent />
    </Layout>
  );
}